import { render, staticRenderFns } from "./AddTaskTagSelector.vue?vue&type=template&id=3d5c9521&scoped=true&"
import script from "./AddTaskTagSelector.vue?vue&type=script&lang=js&"
export * from "./AddTaskTagSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c9521",
  null
  
)

export default component.exports